import React from "react";

export default function HomeSectionHeading({
  eyebrow,
  title,
  lead,
  align = "left",
  tone = "default",
  size = "default",
  className = "",
}) {
  const alignClass = align === "center" ? "items-center text-center" : "items-start text-left";
  const toneClass = tone === "inverse" ? "public-home-premium__section-heading--inverse" : "";
  const sizeClass = size === "feature" ? "public-home-premium__section-heading--feature" : "";
  const titleLines = String(title || "").split("\n").filter(Boolean);

  return (
    <div
      className={`public-home-premium__section-heading flex max-w-3xl flex-col gap-4 ${alignClass} ${toneClass} ${sizeClass} ${className}`.trim()}
    >
      {eyebrow ? (
        <span className="public-home-premium__eyebrow">
          {eyebrow}
        </span>
      ) : null}
      <h2 className="public-home-premium__section-title">
        {titleLines.length > 1
          ? titleLines.map((line, index) => (
            <span key={`${line}-${index}`} className="block">
              {line}
            </span>
          ))
          : title}
      </h2>
      {lead ? (
        <p className="public-home-premium__section-lead">
          {lead}
        </p>
      ) : null}
    </div>
  );
}
